<template>
  <div class="w-full h-full p-4 pl-0">
    <div class="w-full h-full relative">
      <div class="w-full h-full absolute bg-secondary rounded-content-lg"></div>
      <div
        class="w-full h-full pt-8 overflow-hidden rounded-3xl flex flex-col items-center relative"
      >
        <div class="py-8"></div>
        <div class="text-center text-4xl text-white font-bold w-3/4">
          {{ slides[activeSlide].title }}
        </div>
        <div class="py-4"></div>
        <div class="h-[70vh] mt-auto w-full overflow-hidden">
          <swiper-container
            ref="swiper"
            :slides-per-view="'1'"
            space-between="0"
            centered-slides="false"
            autoplay-delay="6000"
            init="false"
            pagination="true"
            autoplay-disable-on-interaction="false"
            class="w-full h-full"
          >
            <swiper-slide class="h-full" v-for="(slide, i) in slides" :key="i">
              <div class="w-full h-full relative p-8"
              >
                <img
                  :src="slide.image"
                  alt=""
                  class="w-full h-full object-contain overflow-hidden "
                  style="mix-blend-mode: multiply"
                />
              </div>
            </swiper-slide>
          </swiper-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import welcomPic1 from '@/assets/images/welcomePictures/pic1.png'

export default {
  components: {},
  data() {
    return {
      eventsIds: [],
      animateOut: false,
      activeSlide: 0,
      slides: [
        {
          title: "Tableau d'administration Ekidiscount",
          image: welcomPic1,
        },
        // {
        //   title: 'Créez votre propre boutique et livrez vos clients',
        //   image: welcomPic3,
        // },
        // { title: "Traquez l'évolution de vos ventes", image: welcomPic2 },
      ],
    }
  },
  mounted() {
    this.initSlider()
    this.tryToLoadGoogleLoginUser()
    const id = this.$Events.handleEvent(
      'bad_login_method',
      this.onBadLoginMethod,
    )
    const id2 = this.$Events.handleEvent(
      'google_registration_failed',
      this.onGoogleRegistrationFailed,
    )
    const id3 = this.$Events.handleEvent(
      'google_registration_done',
      this.onGoogleRegistrationDone,
    )
    const id4 = this.$Events.handleEvent(
      'google_login_done',
      this.onGoogleLoginDone,
    )
    this.eventsIds.push(id)
    this.eventsIds.push(id2)
    this.eventsIds.push(id3)
    this.eventsIds.push(id4)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    initSlider() {
      const swiperComponent = this.$refs.swiper
      const params = {
        injectStyles: [
          `
        .swiper-pagination {
          margin-top:0;
          position: absolute;
          width: 100%!important;
          --swiper-pagination-bullet-width: 7px;
          --swiper-pagination-bottom: none;
          --swiper-pagination-top: 0px;
          --swiper-pagination-bullet-height: 7px;
          --swiper-pagination-bullet-inactive-opacity: 1;
          --swiper-pagination-bullet-inactive-color: red;
        }
      `,
          `
        .swiper-pagination-bullet {
          background-color:#fff6;
          transition-duration: 300ms;
          border-radius:99px;
          padding-right: 0px
        }
      `,
          `
        .swiper-pagination-bullet-active {
          background-color: white;
          padding-right: 20px;
        }
      `,
        ],
      }

      Object.assign(swiperComponent, params)

      swiperComponent.initialize()
      const swiper = swiperComponent.swiper
      swiper.on('slideChange', () => {
        this.activeSlide = swiper.activeIndex
      })
    },
    tryToLoadGoogleLoginUser() {
      if (!window.queryParamsData) return
      console.log(window.queryParamsData)
      let parsed = {}
      try {
        parsed = JSON.parse(window.queryParamsData)
      } catch (error) {
        console.warn(error)
        return
      }
      if (parsed.statusCode !== 200) {
        console.log(parsed)
        return
      }
      if (!parsed.data) return
      const decodedData = atob(parsed.data)
      let userData = {}
      try {
        userData = JSON.parse(decodedData)
      } catch (error) {
        console.warn(error)
        return
      }
      console.log(userData)
      if (userData.id && userData.email) {
        window.queryParamsData = null
        delete window.queryParamsData
        this.$Events.dispatchEvent('start_loading', {
          title: 'Connexion en cours',
        })
        this.$Events.dispatchEvent('google_login_data_available', userData)
      }
    },
    onBadLoginMethod() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Connectez-vous avec votre email et mot de passe',
        body: 'Veuillez vous connecter avec la méthode que vous aviez utiliser lors de la création de votre compte',
      })
    },
    onGoogleRegistrationFailed() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'La création de votre compte a échoué',
        body: 'Veuillez réessayer à nouveau ou démarrer avec votre email et un mot de passe',
      })
    },
    onGoogleRegistrationDone(userData) {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('registration_done', userData)
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Inscription Réussie.',
        body: 'Bienvenue ' + userData?.firstName,
      })
    },
    onGoogleLoginDone(userData) {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Connexion Réussie.',
        body: 'Bon retour ' + userData?.firstName,
      })

      this.$Events.dispatchEvent('login_done', userData)
    },
  },
}
</script>
